import { DateRangePicker, type DateRangePreset, type DateRangeValue } from "@/components/dashboard";
import { Card, CardContent } from "@/components/ui/card";
import { Filter } from "lucide-react";

const startOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
const endOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

export const DASHBOARD_PRESETS: DateRangePreset[] = [
  {
    key: "this_week",
    label: "This week",
    resolve: () => {
      const now = new Date();
      const start = startOfDay(new Date());
      start.setDate(now.getDate() - now.getDay());
      return { from: start, to: endOfDay(now) };
    },
  },
  {
    key: "this_month",
    label: "This month",
    resolve: () => {
      const now = new Date();
      return { from: startOfDay(new Date(now.getFullYear(), now.getMonth(), 1)), to: endOfDay(now) };
    },
  },
  {
    key: "last_30",
    label: "Last 30 days",
    resolve: () => {
      const to = endOfDay(new Date());
      const from = startOfDay(new Date());
      from.setDate(from.getDate() - 29);
      return { from, to };
    },
  },
  {
    key: "last_90",
    label: "Last 90 days",
    resolve: () => {
      const to = endOfDay(new Date());
      const from = startOfDay(new Date());
      from.setDate(from.getDate() - 89);
      return { from, to };
    },
  },
  {
    key: "this_year",
    label: "This year",
    resolve: () => {
      const now = new Date();
      return { from: startOfDay(new Date(now.getFullYear(), 0, 1)), to: endOfDay(now) };
    },
  },
  {
    key: "all_time",
    label: "All time",
    resolve: () => ({ from: null, to: null }),
  },
];

export type DashboardPeriodFilterProps = {
  value: DateRangeValue;
  onChange: (range: DateRangeValue) => void;
};

export function DashboardPeriodFilter({ value, onChange }: DashboardPeriodFilterProps) {
  return (
    <Card className="border-none shadow-sm" data-testid="card-period-filter">
      <CardContent className="p-4 flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm font-medium text-muted-foreground">Period</span>
        </div>
        <DateRangePicker
          value={value}
          onChange={onChange}
          presets={DASHBOARD_PRESETS}
          placeholder="All time"
          testId="dashboard-date-range"
        />
      </CardContent>
    </Card>
  );
}

export default DashboardPeriodFilter;
